import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import ImageGallery from 'components/Luxkit/Carousel/ImageGallery'

const Container = styled.div`
  position: relative;
  width: 100%;
  padding: ${rem(20)};

  background-color: ${(props) => props.theme.palette.neutral.eight};
  border: 1px solid ${(props) => props.theme.palette.neutral.five};

  display: flex;
  flex-direction: column;
  gap: ${rem(20)};

  ${mediaQueryUp.sm} {
    flex-direction: row;
  }
`

const ImagesContainer = styled.div`
  position: relative;
  width: 100%;

  ${mediaQueryUp.sm} {
    height: ${rem(250)};
  }
`

const Content = styled.div`
  width: 100%;
  height: 100%;
`

interface Props {
  room: App.PackageRoomType
  className?: string
}

export default function BaseBundleOptionItemTile({
  room,
  children,
  className,
}: PropsWithChildren<Props>) {
  return (
    <Container className={className}>
      {room?.images.length > 0 && (
        <ImagesContainer>
          <ImageGallery
            images={room.images}
            size="small"
            showImageTitles={false}
            imageParams={{ xs: '5:2', sm: '7:5', quality: 'good', fit: 'none' }}
          />
        </ImagesContainer>
      )}
      <Content>{children}</Content>
    </Container>
  )
}
